import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const SignContainer = () => {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCode(e.target.value);
    setError('');
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (code === 'resom') {
      sessionStorage.setItem('sign', import.meta.env.VITE_SECRET_RESOM_CODE);
      navigate('/resom/space');
    } else if (code === 'avnfrgg') {
      sessionStorage.setItem('sign', import.meta.env.VITE_SECRET_AVNFR_GG_CODE);
      navigate('/avnfr-gg/space');
    } else if (code === 'mauna') {
      sessionStorage.setItem(
        'sign',
        import.meta.env.VITE_SECRET_MAUNA_CODE || 'mauna_secret'
      );
      navigate('/mauna/space');
    } else if (code === 'midas') {
      sessionStorage.setItem(
        'sign',
        import.meta.env.VITE_SECRET_DAEKYO_CODE || 'daekyo_secret'
      );
      navigate('/daekyo/space');
    } else {
      setError('유효하지 않은 코드입니다.');
    }
  };

  return (
    <Container>
      <SignForm onSubmit={handleSubmit}>
        <Title>관리자 로그인</Title>
        <CodeInput
          type="password"
          value={code}
          onChange={handleCodeChange}
          placeholder="관리자 코드를 입력해주세요"
          autoFocus
        />
        <SubmitButton type="submit">확인</SubmitButton>
        {error && <ErrorMessage>{error}</ErrorMessage>}
      </SignForm>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
  background-color: #f5f5f5;
`;

const SignForm = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 400px;
`;

const Title = styled.h1`
  margin-bottom: 1rem;
  color: #333;
  font-size: 1.4rem;
  font-weight: 700;
`;

const CodeInput = styled.input`
  width: 100%;
  padding: 1rem;
  margin-bottom: 1rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
  text-align: center;
  letter-spacing: 0.1rem;

  &:focus {
    outline: none;
    border-color: #4a90e2;
    box-shadow: 0 0 0 2px rgba(74, 144, 226, 0.2);
  }
`;

const SubmitButton = styled.button`
  width: 100%;
  padding: 1rem;
  background-color: #4a90e2;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  font-weight: 700;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #3a80d2;
  }
`;

const ErrorMessage = styled.p`
  color: #e74c3c;
  margin-top: 1rem;
  font-size: 0.9rem;
`;

export default SignContainer;
